import * as actionTypes from "~/store/action_types";

const currencies = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.ANGULAR_INIT_CURRENCIES: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { currencies } = entities;

      if (currencies) {
        return currencies;
      }
      return state;
    }
    case actionTypes.EDIT_DEFAULT_CURRENCY_SUCCESS: {
      const previous = Object.values(state).find((curr) => curr.is_default);
      if (previous) {
        const { response = {} } = action;
        const { entities = {} } = response;
        const { currencies = {} } = entities;

        return {
          ...state,
          ...currencies,
          [previous.id]: {
            ...previous,
            is_default: false,
          },
        };
      }
      return state;
    }
    default:
      return state;
  }
};

export default currencies;
